import api from "./api";

const API_PATH = "/documents";

// =====================================================
// HELPERS
// =====================================================

const mapDocument = (doc) => ({
  ...doc,

  downloadUrl:
    `${api.defaults.baseURL}${API_PATH}/${doc.id}/download`,

  previewUrl:
    `${api.defaults.baseURL}${API_PATH}/${doc.id}/preview`,
});

// =====================================================
// GET ALL
// =====================================================

export const getDocuments = async () => {
  const res = await api.get(API_PATH);

  return Array.isArray(res.data)
    ? res.data.map(mapDocument)
    : [];
};

// =====================================================
// GET DOCUMENTS FOR ACTIVITY
// =====================================================

export const getActivityDocuments = async (activityId) => {
  const res = await api.get(
    `${API_PATH}/activity/${activityId}`
  );

  return Array.isArray(res.data)
    ? res.data.map(mapDocument)
    : [];
};

// =====================================================
// UPLOAD DOCUMENT
// =====================================================

export const uploadDocument = async (formData) => {
  const res = await api.post(API_PATH, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return mapDocument(res.data);
};

// =====================================================
// UPLOAD DOCUMENT FOR COMMUNITY
// (ingen aktivitet)
// =====================================================

export const uploadCommunityDocument = async (file) => {
  const formData = new FormData();

  formData.append("file", file);

  // dokumentet hör inte till någon aktivitet
  formData.append("activityId", "");

  const res = await api.post(API_PATH, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return mapDocument(res.data);
};

// =====================================================
// UPDATE TAGS
// =====================================================

export const updateDocumentTags = async (id, tags) => {
  const safeTags = Array.isArray(tags)
    ? tags
    : [tags];

  const res = await api.put(
    `${API_PATH}/${id}/tags`,
    {
      tags: safeTags,
    }
  );

  return mapDocument(res.data);
};

// =====================================================
// DELETE
// =====================================================

export const deleteDocument = async (id) => {
  await api.delete(`${API_PATH}/${id}`);
};

// =====================================================
// DOWNLOAD
// =====================================================

export const downloadDocument = async (doc) => {
  const res = await api.get(
    `${API_PATH}/${doc.id}/download`,
    {
      responseType: "blob",
    }
  );

  const url = window.URL.createObjectURL(res.data);

  const link = document.createElement("a");

  link.href = url;
  link.download =
    doc.filename ||
    doc.name ||
    "dokument";

  document.body.appendChild(link);
  link.click();
  link.remove();

  window.URL.revokeObjectURL(url);
};

// =====================================================
// FETCH BLOB (PREVIEW)
// =====================================================

export const fetchDocumentBlob = async (doc) => {
  const res = await api.get(
    `${API_PATH}/${doc.id}/download`,
    {
      responseType: "blob",
    }
  );

  return res.data;
};

// =====================================================
// PREVIEW DOCUMENT
// =====================================================

// =====================================================
// PREVIEW
// =====================================================

export const previewDocument = async (doc) => {

  if(!doc?.id){
    throw new Error("Dokument saknar id");
  }


  const res = await api.get(
    `${API_PATH}/${doc.id}/preview`,
    {
      responseType: "blob",
    }
  );


  const blob = new Blob(
    [res.data],
    {
      type:
        res.headers["content-type"]
        ||
        doc.mimeType
        ||
        "application/octet-stream"
    }
  );


  return URL.createObjectURL(blob);

};
// =====================================================
// MERGE PDF
// =====================================================

export const mergeDocuments = async (documentIds) => {
  const res = await api.post(
    `${API_PATH}/merge`,
    {
      documentIds,
    },
    {
      responseType: "blob",
    }
  );

  return res.data;
};

// =====================================================
// DEFAULT EXPORT
// =====================================================

export default {
  getDocuments,
  getActivityDocuments,
  uploadDocument,
  uploadCommunityDocument,
  updateDocumentTags,
  deleteDocument,
  downloadDocument,
  fetchDocumentBlob,
  previewDocument,
  mergeDocuments,
};